import React, { useEffect } from 'react';
import { InputAdornment, MenuItem, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ExpandMore } from '@mui/icons-material';
import { useFormContext } from 'react-hook-form';
import { COLORS } from '../../../utils/Application_Constants';
import {
    currencies,
    textFieldStyles,
    USDollarCurrency,
} from '../../Configurations/ExpenseEntryConfig';

const styles = makeStyles((theme) => {
    const baseStyles = textFieldStyles(theme);
    return {
        ...baseStyles,
        selectIcon: {
            ...baseStyles.selectIcon,
            color: 'inherit',
            '&.Mui-disabled': {
                display: 'none',
            },
        },
        inputAdornmentRoot: {
            border: 'none',
            borderRadius: 0,
        },
        inputAdornmentSelect: {
            paddingRight: '32px !important',
            background: COLORS.LT_MIDNIGHT5,
            fontSize: '14px',
        },
        inputAdornmentDisabled: {
            paddingRight: '24px !important',
        },
        positionEnd: {
            marginLeft: 0,
        },
    };
});

export const AmountCurrencyInputAdornment = ({
    name,
    disabled,
    index,
    currencyType = USDollarCurrency.value,
}) => {
    const classes = styles();
    const { watch, setValue } = useFormContext();
    const fieldName = name ?? `expenseEntries[${index}].currency`;
    const value = watch(fieldName) ?? '';

    useEffect(() => {
        // if the value is not set, set the default value to the currency type (so that the field is registered in the form)
        if (!value && currencyType && value !== currencyType) {
            setValue(fieldName, currencyType);
        }
    }, [value, currencyType, fieldName, setValue]);

    return (
        <InputAdornment position="end" classes={{ positionEnd: classes.positionEnd }}>
            <TextField
                name={fieldName}
                variant="standard"
                id="expense-currency"
                classes={{ root: classes.root }}
                select
                InputProps={{
                    classes: {
                        root: classes.inputAdornmentRoot,
                        input: classes.input,
                    },
                    disableUnderline: true,
                }}
                onChange={(e) =>
                    setValue(fieldName, e.target.value, { shouldDirty: true, shouldValidate: true })
                }
                value={value}
                disabled={disabled}
                SelectProps={{
                    classes: {
                        select: classes.inputAdornmentSelect,
                        icon: classes.selectIcon,
                        disabled: classes.inputAdornmentDisabled,
                    },
                    IconComponent: ExpandMore,
                    MenuProps: {
                        MenuListProps: { id: 'expense-currency-menu' },
                    },
                }}
            >
                {currencies.map(({ name: currencyName, value: currencyValue }, currencyIndex) => (
                    <MenuItem
                        key={currencyValue}
                        value={currencyValue}
                        id={`expense-currency-menu-option-${currencyIndex}`}
                    >
                        {currencyName}
                    </MenuItem>
                ))}
            </TextField>
        </InputAdornment>
    );
};

export default AmountCurrencyInputAdornment;
